import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import TaskModalFile from './files_section_file';

class FilesSection extends Component {
	render() {
		const {task, isProjectLocked} = this.props;
		const {files, googleDriveFiles} = task;
		// Task modal has been throwing errors in production , due to missing data on the task. We're looking into it.
		if (task.files == null || googleDriveFiles == null) {
			return <div className={'error-files-empty'} />;
		}
		//Don't render the section if there are no files
		if (!files.edges.length && !googleDriveFiles.edges.length) return null;

		return (
			<div className="task-modal-v3-files-section" data-cy="task-modal-files-section">
				<div className="files-section-content">
					<div className="files-list" data-cy="task-modal-files-list">
						{files.edges.map(fileEdge => fileEdge.node && <TaskModalFile key={fileEdge.node.id} isProjectLocked={isProjectLocked} file={fileEdge.node} task={task} />)}
						{googleDriveFiles.edges.map(fileEdge => (
							<TaskModalFile key={fileEdge.node.id} isProjectLocked={isProjectLocked} file={fileEdge.node} task={task} gDriveFile={true} />
						))}
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(FilesSection);
